var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-footer',{staticClass:"footer justify-end",attrs:{"app":"","absolute":"","inset":"","color":"transparent"}},[_c('span',{staticClass:"secondary--text"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" fluidd: v"+_vm._s(_vm.appInfo.version)+"-"+_vm._s(_vm.appInfo.hash)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }